import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class RoleService {

    constructor(private httpClient: HttpClient) { }

    private handleError(error: any) {
        return throwError(error);
    }
    // Get role List
    getRoles(pageIndex: any, limit: any, searchFilter: any): Observable<any> {
        const filter = searchFilter ? '&search=' + searchFilter : ''

        return this.httpClient
            .get(environment.baseURL + `/roles?page=${pageIndex}&limit=${limit}${filter}`)
            .pipe(catchError(this.handleError));
    }

    // Get Role Module
    getModules(): Observable<any> {
        return this.httpClient
            .get(environment.baseURL + `/modules`)
            .pipe(catchError(this.handleError));
    }

    // Get Role By Id
    GetRoleById(userId: number): Observable<any> {
        return this.httpClient
            .get(environment.baseURL + `/roles/${userId}`)
            .pipe(catchError(this.handleError));
    }

    // Delete role
    DeleteRole(Id: number): Observable<any> {
        return this.httpClient
            .delete(environment.baseURL + `/roles/${Id}/delete`)
            .pipe(catchError(this.handleError));
    }

    // Create role
    CreateRole(data: any): Observable<any> {
        return this.httpClient
            .post(environment.baseURL + `/roles/create`, data)
            .pipe(catchError(this.handleError));
    }

    // Update Role
    UpdateRole(Id: any, data: any): Observable<any> {
        return this.httpClient
            .put(environment.baseURL + `/roles/${Id}/update`, data)
            .pipe(catchError(this.handleError));
    }
}